import { http } from './http';
import { defineQuery, invalidateQueries } from './queryCache';

export const userApi = {
  listUsers: defineQuery('users', () => http.get('/users').then(r => r.data)),

  getUser: async (username) => {
    const response = await http.get(`/users/${username}`);
    return response.data;
  },

  createUser: async (userData) => {
    const response = await http.post('/users', userData);
    invalidateQueries('users', { discard: true });
    return response.data;
  },

  deleteUser: async (username) => {
    const response = await http.delete(`/users/${username}`);
    invalidateQueries('users', { discard: true });
    return response.data;
  },

  updateUserRole: async (username, role) => {
    const response = await http.put(`/users/${username}/role`, { role });
    invalidateQueries('users', { discard: true });
    return response.data;
  }
};
